import { createContext } from 'react';
export const defaultCardContext = {
  compact: false
};
export const compactCardContext = {
  compact: true
};
export const CardContext = /*#__PURE__*/createContext(defaultCardContext);
const {
  Provider
} = CardContext;
export { Provider as CardContextProvider };